/*---------------------------------------------------------------------------------------------
 * Copyright (c) Bentley Systems, Incorporated. All rights reserved.
 * See LICENSE.md in the project root for license terms and full copyright notice.
 *--------------------------------------------------------------------------------------------*/
import React from 'react';
export var ColorPickerContext = React.createContext(undefined);
export var useColorPickerContext = function () {
    var context = React.useContext(ColorPickerContext);
    if (context == undefined) {
        throw new Error('useColorPickerContext must be used within a ColorPickerContext.Provider');
    }
    return context;
};
